import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule } from '../button';
import { ImageModule } from '../image/image.module';
import { SvgIconModule } from '../svg-icon';

import { MasterBannerComponent } from './master-banner.component';

@NgModule({
  declarations: [MasterBannerComponent],
  imports: [CommonModule, ImageModule, SvgIconModule, ButtonModule],
  exports: [MasterBannerComponent]
})
export class MasterBannerModule {}

export * from './master-banner.component';
